export default __webpack_public_path__ + "locales/ja-JP/SendInviteDialog.json?hash=8bc4c3d5dc3245052afade8fc273d1d6";